// extracted by mini-css-extract-plugin
export var box = "post-comment-module--box--eaaec";
export var comment = "post-comment-module--comment--e8793";
export var email = "post-comment-module--email--3373b";
export var error = "post-comment-module--error--47cd5";
export var flex = "post-comment-module--flex--5036d";
export var flexbox = "post-comment-module--flexbox--b498f";
export var gatsbyRespImageBackgroundImage = "post-comment-module--gatsby-resp-image-background-image--37b3e";
export var gatsbyRespImageLink = "post-comment-module--gatsby-resp-image-link--ebdf0";
export var input = "post-comment-module--input--3867a";
export var load8 = "post-comment-module--load8--c864a";
export var loader = "post-comment-module--loader--106de";
export var name = "post-comment-module--name--8c579";
export var submit = "post-comment-module--submit--2e5d9";